export var check="https://demo.qualitapp.com/ws/upload/mark.png";
export var cancel="https://demo.qualitapp.com/ws/upload/cancel.png";
export var logo="https://demo.qualitapp.com/ws/upload/Logo Brio.png";